import {
  ACCOUNT_DETAILS_PATH,
  BLOCK_DETAILS_PATH,
  CONTRACT_PACKAGE_PATH,
  CONTRACT_PATH,
  DELEGATE_STAKE_PATH,
  DELEGATE_STAKE_SIGN_PATH,
  HOME_PATH,
  UNDELEGATE_STAKE_PATH,
  UNDELEGATE_STAKE_SIGN_PATH,
  VALIDATOR_AUCTION_PATH,
  VALIDATOR_DETAILS_PATH,
  VALIDATOR_LIST_PATH,
} from '../../router/paths';

export const BannerAdZoneIdMap = {
  [HOME_PATH]: {
    desktop: {
      mainnet: '13',
      testnet: '10',
      integration: '10',
      stg: '7',
      dev: '5',
    },
    tablet: {
      mainnet: '14',
      testnet: '11',
      integration: '11',
      stg: '8',
      dev: '6',
    },
    mobile: {
      mainnet: '13',
      testnet: '10',
      integration: '10',
      stg: '7',
      dev: '5',
    },
  },
  [BLOCK_DETAILS_PATH]: {
    desktop: {
      mainnet: '20',
      testnet: '11',
      integration: '11',
      stg: '8',
      dev: '6',
    },
    tablet: {
      mainnet: '20',
      testnet: '11',
      integration: '11',
      stg: '8',
      dev: '6',
    },
    mobile: {
      mainnet: '23',
      testnet: '10',
      integration: '10',
      stg: '7',
      dev: '5',
    },
  },
  [CONTRACT_PACKAGE_PATH]: {
    desktop: {
      mainnet: '20',
      testnet: '11',
      integration: '11',
      stg: '8',
      dev: '6',
    },
    tablet: {
      mainnet: '20',
      testnet: '11',
      integration: '11',
      stg: '8',
      dev: '6',
    },
    mobile: {
      mainnet: '23',
      testnet: '10',
      integration: '10',
      stg: '7',
      dev: '5',
    },
  },
  [CONTRACT_PATH]: {
    desktop: {
      mainnet: '20',
      testnet: '11',
      integration: '11',
      stg: '8',
      dev: '6',
    },
    tablet: {
      mainnet: '20',
      testnet: '11',
      integration: '11',
      stg: '8',
      dev: '6',
    },
    mobile: {
      mainnet: '23',
      testnet: '10',
      integration: '10',
      stg: '7',
      dev: '5',
    },
  },
  [ACCOUNT_DETAILS_PATH]: {
    desktop: {
      mainnet: '21',
      testnet: '16',
      integration: '16',
      stg: '8',
      dev: '6',
    },
    tablet: {
      mainnet: '21',
      testnet: '16',
      integration: '16',
      stg: '8',
      dev: '6',
    },
    mobile: {
      mainnet: '23',
      testnet: '18',
      integration: '18',
      stg: '7',
      dev: '5',
    },
  },
  [VALIDATOR_DETAILS_PATH]: {
    desktop: {
      mainnet: '22',
      testnet: '17',
      integration: '17',
      stg: '8',
      dev: '6',
    },
    tablet: {
      mainnet: '22',
      testnet: '17',
      integration: '17',
      stg: '8',
      dev: '6',
    },
    mobile: {
      mainnet: '25',
      testnet: '19',
      integration: '19',
      stg: '7',
      dev: '5',
    },
  },
};

export const getTextAdZoneIdMap = (path) => {
  switch (path) {
    case DELEGATE_STAKE_PATH:
    case DELEGATE_STAKE_SIGN_PATH:
    case UNDELEGATE_STAKE_PATH:
    case UNDELEGATE_STAKE_SIGN_PATH:
    case VALIDATOR_AUCTION_PATH:
    case VALIDATOR_LIST_PATH:
    case VALIDATOR_DETAILS_PATH:
      return {
        mainnet: '26',
        testnet: '12',
        integration: '12',
        stg: '9',
        dev: '4',
      };
    default:
      return {
        mainnet: '15',
        testnet: '12',
        integration: '12',
        stg: '9',
        dev: '4',
      };
  }
};
